export const routes = [
  {
    path: '/',
    name: 'home'
  },
  {
    path: '/:locale/',
    component: () => import('@/pages/App'),
    props: true,
    children: [
      {
        name: 'list',
        path: '',
        components: {
          header: () => import('@/components/AppHeader'),
          default: () => import('@/pages/Home'),
          footer: () => import('@/components/AppFooter')
        }
      },
      {
        name: 'home.embed',
        path: 'embed/',
        components: {
          header: () => import('@/components/AppHeaderMiniEmbed'),
          default: () => import('@/pages/Home'),
          footer: () => import('@/components/AppFooterEmbed')
        }
      },
      {
        name: 'home.banner',
        path: 'banner/',
        components: {
          header: () => import('@/components/AppHeaderMiniEmbed'),
          default: () => import('@/pages/HomeBanner'),
        }
      },
      {
        name: 'about.page',
        path: 'about/',
        components: {
          header: () => import('@/components/AppHeader'),
          default: () => import('@/pages/Home'),
          overlay_content: () => import('@/components/AboutContent'),
          footer: () => import('@/components/AppFooter')
        }
      },
      {
        name: 'player.profile.embed',
        path: 'player/:id/embed',
        props: true,
        component: () => import('@/pages/PlayerProfileEmbed')
      },
      {
        path: 'player/:id/',
        name: 'player.profile',
        props: {
          default: true,
          navigation: true
        },
        components: {
          header: () => import('@/components/AppHeaderMini'),
          default: () => import('@/pages/Profile'),
          footer: () => import('@/components/AppFooter')
        }
      },
      {
        name: 'region.page.embed',
        path: 'region/:region_id/embed',
        props: true,
        component: () => import('@/pages/RegionEmbed')
      },
      {
        name: 'region.page',
        path: 'region/:region_id/',
        props: {
          default: true
        },
        components: {
          header: () => import('@/components/AppHeaderMini'),
          default: () => import('@/pages/Region'),
          footer: () => import('@/components/AppFooter')
        }
      },
      {
        name: 'provider.page.embed',
        path: 'provider/:provider_id/embed',
        props: true,
        component: () => import('@/pages/ProviderProfileEmbed')
      },
      {
        name: 'provider.page',
        path: 'provider/:provider_id/',
        props: {
          default: true
        },
        components: {
          header: () => import('@/components/AppHeaderMini'),
          default: () => import('@/pages/Provider'),
          footer: () => import('@/components/AppFooter')
        }
      },
      {
        name: 'country.page',
        path: 'country/:country_id/',
        props: {
          default: true
        },
        components: {
          default: () => import('@/pages/Country')
        }
      }
    ]
  },
]

export default routes
